import { AdminService, GetAttorneyUsersResponseUserDto } from 'app/API';
import type { TPaginatedResponse } from 'app/types/API/TPaginatedResponse';
import type { TCall } from 'app/queries/types/TCall';

type TSorting = {
  orderBy: string;
  orderType: 'asc' | 'desc';
};

export const fetchAllAttorneyUsersForExport = async (
  call: TCall,
  sorting: TSorting,
): Promise<TPaginatedResponse<GetAttorneyUsersResponseUserDto>> => {
  const baseExportParams = {
    skip: '0',
    orderBy: sorting.orderBy,
    orderType: sorting.orderType,
    search: '',
  };
  const countResponse = await call(() =>
    AdminService.getAttorneyUsersList({
      ...baseExportParams,
      take: '1',
    }),
  );

  if (countResponse.count === 0) {
    return { count: 0, data: [] };
  }

  return call(() =>
    AdminService.getAttorneyUsersList({
      ...baseExportParams,
      take: countResponse.count.toString(),
    }),
  );
};
